import React from 'react';
import { StyledDiv } from '../../../Theme/CommonStyled';
import Icon from '../Icon';
import { StyledTile, StyledTileContainer } from './style';
import InstagramIcon from '../../../Assets/images/instagram.svg';

type ContactUsTileType = {
  icon?: string;
  onClick?: () => void;
  title: string;
  href?: string;
  target?: string;
  disabled?: boolean;
  isSquare?: boolean;
  height?: string;
};
const ContactUsTile: React.FC<ContactUsTileType> = ({
  icon,
  onClick,
  title,
  href,
  target,
  disabled,
  isSquare = false,
  height = '66px'
}) => {
  return (
    <StyledDiv display="flex" flexDirection="column">
      <StyledTileContainer href={href} target={target}>
        <StyledTile
          onClick={() => {
            !disabled && onClick && onClick();
          }}
          isSquare={isSquare}
          height={height}>
          {icon !== 'instagram' ? (
            <Icon
              name={icon}
              color={disabled ? 'disableBg' : 'normalText'}
              fontSize={14}
            />
          ) : (
            <img src={InstagramIcon} />
          )}
        </StyledTile>
      </StyledTileContainer>
      <StyledDiv
        color={disabled ? 'disableBg' : 'secondaryText'}
        textAlign="center"
        fontSize={2}
        fontWeight={6}
        mt="5px">
        {title}
      </StyledDiv>
    </StyledDiv>
  );
};

export default ContactUsTile;
